"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionTitle = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const section_title_styles_1 = require("./section-title.styles");
const localization_1 = require("../../../localization");
const SectionTitle = ({ title, onClear, children, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    return (react_1.default.createElement(section_title_styles_1.StyledSectionTitle, null, title, react_1.default.createElement("div", { className: "title-actions" }, onClear && (react_1.default.createElement(ui_components_1.Button, { rounded: true, error: true, type: "button", size: "small", onClick: onClear }, t({ key: 'CLEAR' }))), children)));
};
exports.SectionTitle = SectionTitle;
exports.default = exports.SectionTitle;
